import { dispatch } from "react-redux";
import { setLoader, setStatus } from "./User";
import QRGeneratorApi from "../../services/api/QRGenerator";

export const generateQR = (params) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await QRGeneratorApi.generateQR(params);
    dispatch(setLoader(false));
    if (response) {
      return response;
    }
  } catch (err) {
    console.log("error in QRGenerator actions :", err);
    dispatch(setLoader(false));
  }
};

export const fetchVendors = () => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await QRGeneratorApi.fetchVendors();
    dispatch(setLoader(false));
    if (response) {
      return response;
    }
  } catch (err) {
    console.log("error in QRGenerator actions :", err);
    dispatch(setLoader(false));
  }
}

